export default __webpack_public_path__ + "static/media/delete-icon-white.717e5b90.svg";